import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import map from 'lodash/map';
import join from 'lodash/join';
import { ReferenceTypes } from '../../../../../services/citations.service';

@Component({
  selector: 'wk-delete-decorators-dialog',
  templateUrl: './wk-delete-decorators-dialog.component.html',
  styleUrls: ['./wk-delete-decorators-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WKDeleteDecoratorsDialogComponent {
  public readonly isNumberedRef: boolean;
  public readonly citationCount: string;
  public citationStrings: string;

  constructor(
    private readonly wkdialogRef: MatDialogRef<WKDeleteDecoratorsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      citationEditType: ReferenceTypes;
      totalCitedCount?: number;
      citationCount?: string;
      multipleRef?: [{ citationName: string; citationTotalCount: number }];
    }
  ) {
    this.isNumberedRef =
      this.data.citationEditType === ReferenceTypes.NumberedRef ? true : false;
    this.citationCount = this.data.citationCount || null;
    data.multipleRef &&
      (this.citationStrings = join(
        map(data.multipleRef, (item) => `[${item.citationName}]`),
        ','
      ));
  }

  cancel() {
    this.wkdialogRef.close(false);
  }

  //confirm Delete.
  confirm() {
    this.wkdialogRef.close(true);
  }
}
